import { Injectable } from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { CfgService } from '../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class SmsCfg {
  public endpoint: string;
}

@Injectable({
  providedIn: 'root'
})
export class SmsCfgService extends CfgService<SmsCfg> {
  json: any = {
    endpoint: "%{NotificationHubApi}/sendsms"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/sms.cfg.json`;
  }

  /**
 * Carga las url en el json
 */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
